/**
 * User Input
 * @see module:events
 * @module components/Controls
 */
import React from "react";
import * as THREE from 'three';
import PubSub from 'pubsub-js';

import { MOUSE_CLICK, MOUSE_MOVE, MOUSE_DRAG_START, MOUSE_DRAG, MOUSE_DRAG_END, MOUSE_WHEEL, 
            KEY_DOWN, KEY_UP, KEY_MOVE, KEY_STOP } from '../events.js';

export default class Controls extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isMouseDown: false,
            isDragging: false,
            scrollDirection: 0,
            position: new THREE.Vector2(),
            dragOrigin: null,
            dragDistance: null //needed?
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('keyup', this.handleKeyup);


        /*const pubSubEventConsole = (msg, data) => {
            console.log(msg, data);
        }
        PubSub.subscribe(MOUSE_CLICK, pubSubEventConsole);        
        PubSub.subscribe(MOUSE_WHEEL, pubSubEventConsole);   
        PubSub.subscribe(MOUSE_DRAG_START, pubSubEventConsole);
        //PubSub.subscribe(MOUSE_MOVE, pubSubEventConsole);
        PubSub.subscribe(MOUSE_DRAG, pubSubEventConsole);   
        PubSub.subscribe(MOUSE_DRAG_END, pubSubEventConsole);*/
    }

    handleKeydown = (e) => {
        switch(e.keyCode) {
            case 38: //up
            case 87: //W
                this.setState({scrollDirection: 4});
                PubSub.publish(KEY_MOVE, -1);
                break;
            case 40: //down
            case 83: //S
                this.setState({scrollDirection: -4});
                PubSub.publish(KEY_MOVE, 1);
                break;
            case 37: //left
            case 65: //A
                PubSub.publish(KEY_DOWN, 'left');
                break;
            case 39: //right
            case 68: //D
                PubSub.publish(KEY_DOWN, 'right');
                break;
        }
    }

    handleKeyup = (e) => {
        switch(e.keyCode) {
            case 38: //up
            case 40: //down
            case 87: //W
            case 83: //S
                this.setState({scrollDirection: 0});
                PubSub.publish(KEY_STOP);
                break;
            case 37: //left
            case 65: //A
                PubSub.publish(KEY_UP, 'left');
                break;
            case 39: //right
            case 68: //D
                PubSub.publish(KEY_UP, 'right');
                break;
        }
    }

    handleMouseMove = (e) => {
        const position = new THREE.Vector2(e.clientX, e.clientY);
        let dragDistance = null;
        let isDragging = this.state.isDragging;
        
        PubSub.publish(MOUSE_MOVE, position);

        if(this.state.isMouseDown) {

            dragDistance = position.clone();
            dragDistance.sub(this.state.dragOrigin);

            if(dragDistance.length() > 1 ) {
                isDragging = true;
                if(!this.state.isDragging) PubSub.publish(MOUSE_DRAG_START, position);
            }
        }

        if(this.state.isDragging) {
            PubSub.publish(MOUSE_DRAG, dragDistance);
        }

        this.setState({position, isDragging, dragDistance});
    }

    handleWheel = (e) => {
        let scrollY = 0;
        //taken from three-trackballcontrols
        switch ( e.deltaMode ) {
            case 2: //pages
                scrollY = event.deltaY * 0.025;
                break;
            case 1: //lines
                scrollY = event.deltaY * 0.01;
                break;
            default: //pixels
                scrollY = event.deltaY * 0.00025;
                break;
        }

      PubSub.publish(MOUSE_WHEEL, scrollY);
    }

    handleMouseDown = (e) => {
        const dragOrigin = new THREE.Vector2(e.clientX, e.clientY);
        this.setState({isMouseDown: true, dragOrigin});
    }

    handleMouseUp = (e) => {

        if(this.state.isDragging) {
            PubSub.publish(MOUSE_DRAG_END);
        } else {
            PubSub.publish(MOUSE_CLICK);
        }

        this.setState({
          dragOrigin: null,
          isMouseDown: false,
          isDragging: false
        });
    }

    render() {

      let className = 'mouse';
      if(this.state.isDragging) className += ' mouse--dragging';

        return (
            <div className={className}
              onMouseMove={this.handleMouseMove}
              onWheel={this.handleWheel}
              onMouseDown={this.handleMouseDown}
              onMouseUp={this.handleMouseUp}></div>
        )
    }
}
